import { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle`
  @property --countdown-progress {
    syntax: '<number>';
    inherits: false;
    initial-value: 1;
  }

  html {
    /* Note: 1rem = 10px */
    font-size: 62.5% !important;
  }

  body {
    font-size: 1.6rem !important;
  }

  // NOTE: This will target only svg icons displayed as squares
  svg[width][height] {
    flex-shrink: 0;
  }

  img, svg {
    display: flex;
  }

  img,
  svg * {
    user-select: none;
  }

  svg * {
    pointer-events: none;
  }

  /* Note: Fix for double scroll bar issue in react-query-devtools. Issue is caused by the default height of 100% being set on the #app container. */
  .tsqd-parent-container {
    height: auto !important;
  }
`
